class ScrollToTop {
  constructor() {
    this.init()
  }

  scrollEvent = () => {
    let button = document.querySelector(".sticky-variant-selector-wrapper");
    if(window.innerWidth < 767) {
      window.addEventListener('scroll', () => {
        if (document.documentElement.scrollTop > 1140.800048828125) {
          button.classList.add('active');
        } else {
          button.classList.remove('active');
        }
      });
    }
  }

  init = () => {
    this.scrollEvent();
  }
}

new ScrollToTop();